import { UIHeading4 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './Features.css';

export interface IFeaturesProps {
  features: string[];
  href?: string;
}

export function Separator() {
  return <span className={styles['separator']}>•</span>;
}

function featuresToNodes(features: string[]) {
  return features.reduce((result, feature, index, { length }) => {
    result.push(
      <UIHeading4 key={`feature${index}`} display="inline">
        {feature}
      </UIHeading4>,
      index < length - 1 && <Separator key={`s${index}`} />,
    );

    return result;
  }, [] as React.ReactNode[]);
}

export const Features: React.FC<IFeaturesProps> = ({ features, href }) => {
  const featureNodes = featuresToNodes(features);

  if (href) {
    return (
      <a className={styles['container']} href={href} target="_blank" rel="noreferrer">
        {featureNodes}
      </a>
    );
  }

  return <div className={styles['container']}>{featureNodes}</div>;
};
